/** @format */
import Cookies from 'js-cookie';

import { AvailableMarket } from '@toucan/config/markets';

import { trackViaDataLayer } from '@toucan/helpers/analytics';

export function handleMarketChange(market: AvailableMarket) {
    Cookies.set('mpb_market', market.code);

    trackViaDataLayer({
        event: 'NAVIGATE_TO_MARKET',
        location: 'FOOTER',
    });

    if (market) {
        window.location.assign(`/${market.slug}`);
    }
}
